import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/Globe.tsx
const GlobeIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.73 2.027a1.002 1.002 0 0 0-.351-.02 10 10 0 0 0-.758 0 1.002 1.002 0 0 0-.35.02 10 10 0 0 0 0 19.947c.114.026.233.033.35.019a10.155 10.155 0 0 0 .758 0c.117.014.236.007.35-.02a10 10 0 0 0 0-19.946ZM9.622 4.36a8 8 0 0 0-5.56 6.64H7.95a18 18 0 0 1 1.673-6.64Zm.33 6.64A16 16 0 0 1 12 4.114 16 16 0 0 1 14.046 11H9.954ZM7.95 13H4.063a8 8 0 0 0 5.56 6.638A18 18 0 0 1 7.95 13ZM12 19.884A16 16 0 0 1 9.953 13h4.094A16 16 0 0 1 12 19.885Zm2.377-.246A8 8 0 0 0 19.936 13H16.05a18 18 0 0 1-1.674 6.639ZM16.05 11h3.887a8 8 0 0 0-5.56-6.639 18 18 0 0 1 1.673 6.64Z",
		fill: props.fill || "currentColor"
	})
}));
export { GlobeIcon };
